import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import ForcePasswordChange from './ForcePasswordChange';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, mustChangePassword, requiresTenantSelection } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // Se richiede selezione tenant, redirect alla pagina di selezione
  if (requiresTenantSelection) {
    return <Navigate to="/select-tenant" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      <ForcePasswordChange visible={mustChangePassword} />
    </>
  );
};

export default ProtectedRoute;
